import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Home = () => {

  const services = [
    {
      title: "Title Services",
      description:
        "Title Services designed to ensure the security and validity of property transactions in the Title industry.",
      items: [
        "Order Entry",
        "Current Owner Search",
        "2 Owner Search",
        "Full Search",
        "Document Retrievals",
      ],
      link: "/title-services",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Title Services - Property documents",
      gradientFrom: "from-blue-600",
      gradientTo: "to-blue-800",
      badgeBg: "bg-blue-100",
      badgeText: "text-blue-700",
      checkColor: "text-blue-500",
    },
    {
      title: "Title Commitment & Package",
      description:
        "A structured back-office solution supporting U.S. title agencies, underwriters, and settlement teams with precision and compliance.",
      items: [
        "Title Package Preparation",
        "Document Typing & Data Entry",
        "Chain of Title Review",
        "Lien & Encumbrance Review",
        "Quality Control & Final Review"
      ],
      link: "/title-commitment-services",
      image:
        "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Title Commitment Services - Legal file preparation",
      gradientFrom: "from-red-600",
      gradientTo: "to-rose-800",
      badgeBg: "bg-red-100",
      badgeText: "text-red-700",
      checkColor: "text-red-500",
    },
    {
      title: "Curative Services",
      description:
        "Designed to resolve title defects and ensure the smooth transfer of real estate properties.",
      items: [
        "Payoff Ordering",
        "HOA Estoppels",
        "HOA Dues Status",
        "Municipal Lien Searches",
        "Release Tracking",
      ],
      link: "/curative-services",
      image:
        "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Curative Services - Legal documents",
      gradientFrom: "from-emerald-600",
      gradientTo: "to-emerald-800",
      badgeBg: "bg-emerald-100",
      badgeText: "text-emerald-700",
      checkColor: "text-emerald-500",
    },
    {
      title: "Settlement Services",
      description:
        "We offer Settlement Services to facilitate smooth and successful real estate transactions.",
      items: [
        "CD Preparation",
        "Pre-CD Preparation",
        "Notary Scheduling",
        "Post Closing Audit",
        "Policy Typing",
      ],
      link: "/settlement-services",
      image:
        "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Settlement Services - Signing documents",
      gradientFrom: "from-violet-600",
      gradientTo: "to-violet-800",
      badgeBg: "bg-violet-100",
      badgeText: "text-violet-700",
      checkColor: "text-violet-500",
    },
    {
      title: "Tax Services",
      description:
        "Tax Services tailored to meet the diverse needs of our clients in the real estate and mortgage industries.",
      items: [
        "Tax Certificate",
        "PA & NY Tax Searches",
        "Escrow Tax Services",
        "Delinquency Search",
        "Tax Updates",
      ],
      link: "/tax-services",
      image:
        "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80&auto=format&fit=crop",
      imageAlt: "Tax Services - Financial planning",
      gradientFrom: "from-amber-600",
      gradientTo: "to-amber-800",
      badgeBg: "bg-amber-100",
      badgeText: "text-amber-700",
      checkColor: "text-amber-500",
    },
  ];


  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const data = new FormData(form);
    const phpResponse = await fetch(
      // 'http://localhost/CityPulse/api/contact.php',
      'https://citypulsellc.com/api/contact.php',
      {
        method: 'POST',
        body: data,
      });
    const phpResult = await phpResponse.json();

    if (phpResult.status !== "success") {
      alert("Upload failed");
      return;
    }

    alert("Application submitted successfully!");
    form.reset();
    setLoading(false);
  };

  return (
    <div className="bg-white">

      {/* Hero Section */}
      {/* <section className="relative bg-gradient-to-br from-black to-black text-white overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-60" style={{ backgroundImage: `url('./assets/Images/Wallpaper/Wall_01.jpg')` }} ></div>
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-primary-light/10 to-primary-dark/10"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6  min-h-[60vh] flex items-center justify-center ">
          <div className="text-center">
            <div className="glass-car rounded-2xl p-8 md:p-12 mb-8 inline-block">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 text-white">
                Welcome to{' '}
                <span className="text-white">City Pulse</span>
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-white max-w-3xl mx-auto font-semibold">
                Excellence in Title Services and Settlement Services
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/services"
                  className="glass bg-accent/90 hover:bg-accent text-white font-semibold py-3 px-8 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg"
                >
                  Our Services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-gray-950">

        {/* Background image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url('./assets/Images/Wallpaper/Wall_01.jpg')` }}
        />
        {/* Layered overlays */}
        <div className="absolute inset-0 bg-gradient-to-br from-gray-950/90 via-gray-900/75 to-primary/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950/80 via-transparent to-transparent" />

        {/* Decorative blobs */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary/20 blur-3xl" />
          <div className="absolute -bottom-40 -left-20 w-[500px] h-[500px] rounded-full bg-blue-500/15 blur-3xl" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full bg-primary/10 blur-3xl" />
          {/* Dot grid */}
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage: `radial-gradient(circle, #fff 1px, transparent 1px)`,
              backgroundSize: `36px 36px`,
            }}
          />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:py-32 w-full">
          <div className="flex flex-col items-center text-center">

            {/* Eyebrow badge */}
            <div className="mb-8">
              <span className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-5 py-2 text-xs font-semibold uppercase tracking-widest text-blue-300">
                <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
                Title & Settlement Services
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black text-white leading-none mb-6 max-w-5xl">
              Welcome to
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-300 mt-2">
                City Pulse
              </span>
            </h1>

            {/* Accent divider */}
            <div className="flex items-center gap-4 mb-8">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-blue-400" />
              <div className="w-2 h-2 rounded-full bg-blue-400" />
              <div className="h-px w-12 bg-gradient-to-l from-transparent to-blue-400" />
            </div>

            {/* Subheadline */}
            <p className="text-lg sm:text-xl lg:text-2xl text-gray-300 max-w-2xl leading-relaxed mb-12">
              Excellence in Title Services and Settlement Services — precision, reliability, and compliance at every step.
            </p>

            {/* CTA buttons */}
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-16">
              <Link
                to="/services"
                className="inline-flex items-center gap-2.5 bg-primary hover:bg-primary-dark text-white font-semibold py-4 px-9 rounded-xl transition-all duration-200 hover:scale-105 shadow-2xl shadow-primary/40 text-sm sm:text-base"
              >
                Our Services
                <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2.5 border border-white/25 hover:border-white/50 text-gray-300 hover:text-white font-semibold py-4 px-9 rounded-xl transition-all duration-200 text-sm sm:text-base backdrop-blur-sm"
              >
                Get In Touch
              </Link>
            </div>

            {/* Service tags */}
            <div className="hidden lg:flex flex-wrap justify-center gap-2.5">
              {[
                { label: "Title Services", icon: "🏠" },
                { label: "Curative Services", icon: "📋" },
                { label: "Settlement Services", icon: "🤝" },
                { label: "Tax Services", icon: "💼" },
              ].map((item) => (
                <span
                  key={item.label}
                  className="inline-flex items-center gap-2 bg-white/8 border border-white/12 backdrop-blur-sm rounded-full px-4 py-2 text-sm text-gray-400"
                >
                  <span>{item.icon}</span>
                  {item.label}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom fade */}
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-gray-50 to-transparent" />

        {/* Scroll hint */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
          <span className="text-white text-xs uppercase tracking-widest">Scroll</span>
          <div className="w-px h-8 bg-gradient-to-b from-white to-transparent animate-bounce" />
        </div>
      </section>

      <section className="relative py-24 bg-gray-50 overflow-hidden">
        {/* Background decorations */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-50 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-60 pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-violet-50 rounded-full translate-x-1/2 translate-y-1/2 opacity-60 pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Section Header */}
          <div className="text-center mb-20">
            <span className="inline-block text-sm font-semibold tracking-widest uppercase text-blue-600 mb-3">
              What We Offer
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
              Our Core Services
            </h2>
            <div className="w-16 h-1 bg-blue-600 rounded-full mx-auto mb-6" />
            <p className="text-xl text-gray-500 max-w-3xl mx-auto leading-relaxed">
              Comprehensive Title, Curative, Settlement, and Tax Services designed to
              support secure and compliant real estate transactions.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div
                key={service.title}
                className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-gray-100 flex flex-col"
              >
                {/* Image with gradient overlay */}
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.imageAlt}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-br ${service.gradientFrom} ${service.gradientTo} opacity-60`} />
                  <div className="absolute inset-0 flex flex-col justify-end p-6">
                    <span className={`self-start text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-2 ${service.badgeBg} ${service.badgeText}`}>
                      Service {String(index + 1).padStart(2, "0")}
                    </span>
                    <h3 className="text-2xl font-bold text-white drop-shadow">
                      {service.title}
                    </h3>
                  </div>
                </div>

                {/* Content */}
                <div className="flex flex-col flex-1 p-7">
                  <p className="text-gray-500 mb-5 leading-relaxed text-sm">
                    {service.description}
                  </p>

                  {/* Feature list */}
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-7 flex-1">
                    {service.items.map((item) => (
                      <li key={item} className="flex items-center gap-2 text-gray-700 text-sm">
                        <svg
                          className={`w-4 h-4 flex-shrink-0 ${service.checkColor}`}
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <circle cx="8" cy="8" r="8" fill="currentColor" fillOpacity="0.12" />
                          <path
                            d="M5 8l2 2 4-4"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>

                  {/* CTA */}
                  <div className="pt-5 border-t border-gray-100">
                    <Link
                      to={service.link}
                      className={`inline-flex items-center gap-2 bg-gradient-to-r ${service.gradientFrom} ${service.gradientTo} text-white text-sm font-semibold py-3 px-7 rounded-xl hover:opacity-90 transition-all duration-200 shadow-md group/btn`}
                    >
                      View More
                      <svg
                        className="w-4 h-4 transition-transform duration-200 group-hover/btn:translate-x-1"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M3 8h10M9 4l4 4-4 4"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="relative py-16 overflow-hidden bg-gray-50">
        {/* Background image with overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-gray-900/70 backdrop-blur-sm" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 xl:gap-14 items-center">

            {/* Left — Why Choose Us */}
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 sm:p-8 text-white">
              <span className="inline-block text-xs font-bold uppercase tracking-widest text-blue-300 mb-2">
                Why Us
              </span>
              <h2 className="text-3xl sm:text-4xl font-bold mb-6 leading-tight">
                Why Choose City Pulse?
              </h2>

              <div className="space-y-4">
                {[
                  {
                    title: 'Expert Team',
                    description: 'Deep knowledge of Title, Settlement, and regulatory requirements.',
                    icon: '🎯',
                  },
                  {
                    title: 'Accuracy & Precision',
                    description: 'Highest standards of accuracy maintained across all our services.',
                    icon: '✅',
                  },
                  {
                    title: 'Timely Delivery',
                    description: 'We understand deadlines and deliver results on time, every time.',
                    icon: '⏱️',
                  },
                  {
                    title: 'Comprehensive Support',
                    description: 'From Order Entry to Policy mailing, we offer continuous support to ensure a seamless process.',
                    icon: '🤝',
                  },
                  {
                    title: 'Cost Efficient Solutions',
                    description: 'We prioritize providing high-quality services at affordable prices, our cost-efficient solutions ensure you get the best product without compromising on quality.',
                    icon: '💰',
                  },
                ].map((feature, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-4 p-4 rounded-xl bg-white/10 hover:bg-white/15 transition-colors duration-200"
                  >
                    <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center text-lg">
                      {feature.icon}
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-white mb-0.5">
                        {feature.title}
                      </h3>
                      <p className="text-sm text-gray-300 leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right — Contact Form */}
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8">
              <span className="inline-block text-xs font-bold uppercase tracking-widest text-blue-600 mb-1">
                Contact
              </span>
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-5">
                Send Us a Message
              </h2>

              <form onSubmit={handleSubmit} className="space-y-4">
                {/* Name + Email — side by side on sm+ */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">
                      Full Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-3.5 py-2.5 text-sm border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-gray-50 hover:bg-white focus:bg-white"
                      placeholder="Enter your name"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-3.5 py-2.5 text-sm border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-gray-50 hover:bg-white focus:bg-white"
                      placeholder="Enter your email"
                    />
                  </div>
                </div>

                {/* Phone + Subject — side by side on sm+ */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="phone" className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">
                      Phone <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      className="w-full px-3.5 py-2.5 text-sm border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-gray-50 hover:bg-white focus:bg-white"
                      placeholder="Enter your phone number"
                    />
                  </div>
                  <div>
                    <label htmlFor="city" className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">
                      City <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      required
                      className="w-full px-3.5 py-2.5 text-sm border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-gray-50 hover:bg-white focus:bg-white"
                      placeholder="Enter your city"
                    />
                    {/* <select
                      id="subject"
                      name="subject"
                      required
                      className="w-full px-3.5 py-2.5 text-sm border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-gray-50 hover:bg-white focus:bg-white text-gray-700"
                    >
                      <option value="">Select a subject</option>
                      <option>Services Inquiry</option>
                      <option>Career Opportunity</option>
                      <option>General Inquiry</option>
                      <option>Support Request</option>
                    </select> */}
                  </div>
                </div>

                {/* Message */}
                <div>
                  <label htmlFor="message" className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">
                    Message <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows="4"
                    className="w-full px-3.5 py-2.5 text-sm border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-gray-50 hover:bg-white focus:bg-white resize-none"
                    placeholder="Tell us how we can help you..."
                  />
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-primary hover:bg-primary-dark disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold py-3 px-8 rounded-xl transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-lg text-sm flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <>
                      <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24" fill="none">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                      </svg>
                      Sending...
                    </>
                  ) : (
                    <>
                      Send Message
                      <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none">
                        <path d="M2 8h12M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </>
                  )}
                </button>

                <p className="text-center text-xs text-gray-400 mt-1">
                  We typically respond within 24 hours.
                </p>
              </form>
            </div>

          </div>
        </div>
      </section>



    </div>
  );
};

export default Home;

